module.exports = __webpack_public_path__ + "img/blog-14-3.856a9893.webp";